"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPositive = void 0;
const is_number_1 = require("./is-number");
exports.isPositive = (value) => is_number_1.isNumber(value) && value > 0;
//# sourceMappingURL=is-positive.js.map